export default __webpack_public_path__ + "static/media/verified1.32150443.svg";